"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeleteBucketMetricsConfigurationOutput = {
    type: "structure",
    required: [],
    members: {}
};
//# sourceMappingURL=DeleteBucketMetricsConfigurationOutput.js.map